export const searchParamsToObject = (searchParams) => (
    [...searchParams.entries()].reduce((tot, curr) => {
        return ({
            ...tot,
            [curr[0]]: curr[1],
        });
    }, {})
);